import { useTranslation } from 'react-i18next';
import { useFallbackLanguage } from '../../../i18n';
import { useIsAdmin } from '../utils';
import { PropsWithChildren, useLayoutEffect } from 'react';
import { LOCALISATION, useFeature } from '../utils/togglz';

export const DefaultLanguageRedirect = ({ children }: PropsWithChildren) => {
    const isLocalisationEnabled = useFeature(LOCALISATION);
    const { i18n } = useTranslation();
    const fallbackLanguage = useFallbackLanguage();
    const isAdmin = useIsAdmin();

    useLayoutEffect(() => {
        if ((!isAdmin || !isLocalisationEnabled) && i18n.language !== fallbackLanguage) {
            i18n.changeLanguage(fallbackLanguage).then();
        }
    }, [fallbackLanguage, i18n, isAdmin, isLocalisationEnabled]);

    return <>{children}</>;
};
